const STORE_INIT = 'STORE_INIT';
const STORE_CLEAR = 'STORE_CLEAR';
const START_REQUEST = 'START_REQUEST';
const END_REQUEST = 'END_REQUEST';
const OPEN_DIALOG = 'OPEN_DIALOG';
const CLOSE_DIALOG = 'CLOSE_DIALOG';
const CLOSE_DIALOG_NOT_FORMAT = 'CLOSE_DIALOG_NOT_FORMAT';
const CHECK_ACCESS = 'CHECK_ACCESS';

export default {
    STORE_INIT,
    STORE_CLEAR,
    START_REQUEST,
    END_REQUEST,
    OPEN_DIALOG,
    CLOSE_DIALOG,
    CLOSE_DIALOG_NOT_FORMAT,
    CHECK_ACCESS,
};
